import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  width: "54",
  height: "54",
  viewBox: "0 0 54 54",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("rect", {
  width: "54",
  height: "54",
  fill: "#0B0A0A"
}, null, -1)
const _hoisted_3 = /*#__PURE__*/_createElementVNode("path", {
  "fill-rule": "evenodd",
  "clip-rule": "evenodd",
  d: "M18.5438 27.0001L8.81128 17.6569L14.0323 12.2183L26.5 24.1872V29.813L14.0323 41.782L8.81128 36.3434L18.5438 27.0001Z",
  fill: "currentColor"
}, null, -1)
const _hoisted_4 = /*#__PURE__*/_createElementVNode("path", {
  "fill-rule": "evenodd",
  "clip-rule": "evenodd",
  d: "M37.2326 27.0001L27.5 17.6569L32.7211 12.2183L45.1887 24.1872L45.1887 29.813L32.7211 41.782L27.5 36.3434L37.2326 27.0001Z",
  fill: "currentColor"
}, null, -1)
const _hoisted_5 = [
  _hoisted_2,
  _hoisted_3,
  _hoisted_4
]

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [..._hoisted_5]))
}
export default { render: render }